const multipleData = {
  '认证机构': {
    // 'active': true,
    '认证类别': [
      {
        name: '产品认证',
        id: 'B',
        type: 'category'
      },
      {
        name: '管理体系认证',
        id: 'A',
        type: 'category'
      },
      {
        name: '服务认证',
        id: 'C',
        type: 'category'
      }
    ],
    '认证领域': [
    ]
  }
}
export default multipleData



// WEBPACK FOOTER //
// ./src/layout/common/config/certification.js